
import { Component, Vue } from 'vue-property-decorator';
import { getAllAlternateUrls, getCanonicalUrl } from '~/helpers/metadata';
import type { IAPIArticle } from '@hokify/magazine-interface';
import ArticleCard from '~/components/website/ArticleCard.vue';
import FAQ from '@hokify/shared-components/lib/components/FAQ.vue';
import cvFAQs from '~/data/b2c-lps/cv/cvFAQs.json';
import ContentMediaSplitComponent from '~/components/website/ContentMediaSplitComponent.vue';

@Component({
	name: 'Lebenslauf',
	layout: 'plain-user',
	components: {
		ContentMediaSplitComponent,
		FAQ,
		ArticleCard
	},
	head(this: Lebenslauf) {
		const path = `${this.$store.state.host}/lebenslauf-erstellen`;
		const canonical = getCanonicalUrl(path);
		const alternates = getAllAlternateUrls(path);
		const description =
			'Lebenslauf online erstellen: professionelle und moderne Lebenslauf Vorlagen für jeden Job.  Schnell, kostenlos und einfach!';
		const result: any = {
			title: 'Erstelle kostenlos deinen Lebenslauf aus Vorlagen!',
			link: [canonical, ...alternates],
			meta: [
				{ hid: 'robots', name: 'robots', content: 'index, follow' },
				{
					hid: 'description',
					name: 'description',
					content: description
				}
			]
		};
		return result;
	},
	async asyncData({ store, $sentry }) {
		const articleAliases = [
			'lebenslauf-schreiben-vorlage',
			'bewerbung/lebenslauf-für-schüler-alle-fragen-und-antworten',
			'bewerbung/lücken-im-lebenslauf-was-tun'
		];
		const articles: IAPIArticle[] = [];
		try {
			for (const articleAlias of articleAliases) {
				const { article } = await store.dispatch('magazine/loadArticle', {
					alias: articleAlias
				});
				articles.push(article);
			}
		} catch (err: any) {
			$sentry.captureMessage(`article "${err?.response?.data?.message}" not found`);
		}

		return { articles };
	}
})
export default class Lebenslauf extends Vue {
	cvFAQs = cvFAQs;

	articles: IAPIArticle[] = [];

	linkBoxes = [
		{
			headline: 'Einfach Anmelden',
			text: 'Gib deine E-Mail Adresse sowie deinen Vor- und Nachnamen ein und registriere dich bei hokify.'
		},
		{
			headline: 'Vervollständige deinen Lebenslauf',
			text: 'Leg direkt los und erstelle deinen Lebenslauf. Gib Persönliche Infos, Berufserfahrung und Ausbildungen an. '
		},
		{
			headline: 'Speichere deinen Lebenslauf',
			text: 'Klicke auf "Vorschau & Speichern", danach kannst du ein passendes Design und eine individuelle Farbe wählen.'
		}
	];

	cards = [
		{
			type: 'img',
			mediaPosition: 'right',
			src: 'img/b2c-lps/cv/LebenslaufDesignerSettings.png',
			title: 'hokify Lebenslauf-Designer',
			alt: 'hokify Lebenslauf-Designer Settings',
			text: 'Professioneller Lebenslauf gefällig? Erstelle deinen Lebenslauf aus modernen Design-Vorlagen. Ganz einfach, mit wenigen Schritten am Smartphone zum perfekten Lebenslauf!',
			buttonText: 'Lebenslauf erstellen',
			buttonLink: '/hokifycv'
		},
		{
			type: 'img',
			mediaPosition: 'left',
			src: 'img/b2c-lps/cv/LebenslaufFarben.png',
			title: 'Wähle deine Lieblingsfarbe',
			alt: 'hokify Lebenslauf-Designer Farben',
			text: 'Gestalte deinen Lebenslauf in deiner Lieblingsfarbe und erstelle deinen modernen Lebenslauf mit individueller Farbgebung und Schrift. Hebe dich von anderen Bewerber:innen ab.\n',
			buttonText: 'Farbe wählen',
			buttonLink: '/hokifycv'
		},
		{
			type: 'video',
			mediaPosition: 'right',
			poster: 'video/poster/application-photo-preview.jpeg',
			src: 'https://www.youtube.com/embed/ygqTIxpgMdE',
			title: 'Selfie Bewerbungsfoto',
			alt: 'Bewerbungsfoto Tutorial',
			text: 'Erstelle dein Bewerbungsfoto ganz einfach im Selfie-Format am Smartphone. Wähle einen neutralen Hintergrund, achte auf das richtige Outfit. Wir haben die wichtigsten Infos zum Bewerbungsfoto in diesem Video für dich zusammengefasst.',
			buttonText: 'Foto aufnehmen',
			buttonLink: '/hokifycv'
		}
	];
}
